@if(profileData){
<app-patient-registration-details [inputData]="profileData" [practitionerPurpose]="true"
	(editRequested)="onEditRequested($event)">
</app-patient-registration-details>
}